
document.addEventListener('DOMContentLoaded', function () { 

    const orderFormBackBtn = document.querySelector('.order-form-back-btn a');
    
    if (orderFormBackBtn) {
        orderFormBackBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const orderTab1 = document.querySelector('.e-n-tabs-heading .e-n-tab-title[data-tab-index="1"]');
            if (orderTab1) {
                orderTab1.click();
                goToTop('.e-n-tabs-heading');
            }
        });
    }

    const orderFormNextBtn = document.querySelector('.order-form-next-btn a');
    if (orderFormNextBtn) {
        orderFormNextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const orderTab2 = document.querySelector('.e-n-tabs-heading .e-n-tab-title[data-tab-index="2"]');
            if (orderTab2) {
                orderTab2.click();
                goToTop('.e-n-tabs-heading');
            }
        });
    }

    const orderFormSubmitBtn = document.querySelector('.order-form-submit a');
    if (orderFormSubmitBtn) {
        orderFormSubmitBtn.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('.order-form-submit a').classList.add('disabled');
            document.querySelector('.frm_pro_form .frm_button_submit').click();
        });
    }

    const orderFormSubmitBtnOriginal = document.querySelector('.quixote-order-form-tabs .frm_pro_form .frm_submit');
    if (orderFormSubmitBtnOriginal) {
        orderFormSubmitBtnOriginal.parentElement.classList.add('no-margin-bottom');
    }
});


jQuery(document).on('frmFormErrors', function(event, form, errors) {
    const submitButton = jQuery('.order-form-submit a');
    submitButton.removeClass('disabled');
    goToTop('.e-n-tabs-heading');
});